import axios from "axios";
import { ENTERPRISE_API_URL } from "../configs";


export default axios.create({
    baseURL: ENTERPRISE_API_URL
});
